






import { defineComponent } from '@vue/composition-api';
import pcTransmission from '@/renderer/views/desktop/FileManagement/Transmission/index.vue';
import webTransmission from './webTransmission.vue';
export default defineComponent({
  components: {
    webTransmission,
    pcTransmission,
  },
});
